export default __webpack_public_path__ + "static/media/cp_geo_tt.828de802.svg";